import images from "@app/images";

export const IncCalender01 = images.inc_calender01.default;
export const IncCalender02 = images.inc_calender02.default;
